import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UmssFormsService {
  private readonly baseUrl = 'api/forms';

  private readonly http = inject(HttpClient);

  download(): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/w9-template.pdf`, {
      responseType: 'blob'
    });
  }
}
